import Request from './lib/atd-request.js';
import store from './store/index.js';

const API_URL = window.atdTradeshows.api_domain;

const EMAIL_BLACKLIST = [
    'mailinator.com'
];

class ReservationData {
    static sendReservation(data, recaptcha = null, update = false) {
        // handle email blacklist
        if(EMAIL_BLACKLIST.includes(data.ContactEmail.split('@')[1])) {
            window.location = confirmationPage;
            return;
        }

        Object.keys(data).forEach((key) => {
            if(typeof data[key] === 'string') {
                data[key] = data[key].replace(/\s/g, " ");
            }
        });

        if(!update) {
            window.dataLayer = window.dataLayer || []; window.dataLayer.push({'event': 'nada_form_submit'});
        }

        return Request.post(`${API_URL}/wp-json/atd/nada-submission/submit`, ReservationData.formatData(data, recaptcha)).then((response) => {
            let data = JSON.parse(response);

            if(response === '"recaptcha_invalid"') {
                return response;
            }

            if(!data.willAttend ||  update) {
                this.goToConfirmation(data);
            }
            else {

                store.setSubmissionId(data.submissionId);
                store.setStep('recommendation');

				let validURLPaths = [
					'/nada/xtime/',
					'/nada/dealertrack/',
					'/nada/ddc/',
					'/nada/vinsolutions/',
					'/nada/retail/',
				];

				if (
					validURLPaths.includes( window.location.pathname ) && // phpcs:ignore WordPressVIPMinimum.JS.Window.location
					'undefined' !== typeof GLBLCOKIE &&
					'undefined' !== typeof GLBLCOKIE.storage &&
					'undefined' !== typeof GLBLCOKIE.storage.options
				) {
					let nadaKey = GLBLCOKIE.storage.options.NADAKEY;

					let cookie = GLBLCOKIE.get( false );

					if (
						cookie &&
						null !== cookie &&
						'undefined' !== typeof GLBLCOKIE[ nadaKey ]
					) {
						GLBLCOKIE[ nadaKey ].setValueInCookie( 'showPopup', false );
					}
				}
            }

            return data;
        });
    }

    static goToConfirmation(data) {
        let confirmationPage = (
            data.willAttend || 
            !store.brand.confirmation_not_attending
        ) ? store.brand.confirmation : store.brand.confirmation_not_attending;

        if(data.submissionId) {
            window.location = `${confirmationPage}?submissionId=${data.submissionId}${data.RepId ? '&callcenter=1' : ''}`;
        }
        else {
            window.location = `${confirmationPage}`;
        }
    }

    static autoSave(data, recaptcha = null) {
        // handle email blacklist
        if(EMAIL_BLACKLIST.includes(data.ContactEmail.split('@')[1])) {
            return;
        }

        return Request.post(`${API_URL}/wp-json/atd/nada-submission/autosave`, ReservationData.formatData(data, recaptcha)).then((response) => {
            return JSON.parse(response);
        });
    }

    static formatData(data, recaptcha = null) {
        let formattedData = Object.assign({}, data);

        if(recaptcha) {
            formattedData.recaptcha = recaptcha;
        }

        delete formattedData.validate;

        // truncate sf field lengths to maximum
        if(!formattedData.submissionId) {
            Object.keys(formattedData.sfFieldLengths).forEach((field_name) => {
                if(formattedData[field_name] && formattedData[field_name].length > formattedData.sfFieldLengths[field_name]) {
                    formattedData[field_name] = formattedData[field_name].slice(0,formattedData.sfFieldLengths[field_name]);
                }
            });
            delete formattedData.sfFieldLengths;
        }

        Object.keys(formattedData.selections).forEach((brand) => {
            if(formattedData.selections[brand].products) {
                let products = [];
                formattedData.selections[brand].products.forEach((product) => {
                    products.push({
                        'ID': product.ID,
                        'title': product.title,
                        'field_name': product.field_name,
                        'brand_slug': product.brand_slug,
                        'additional_mappings': product.additional_mappings,
                        'state_mappings': product.state_mappings,
                        'booth': product.booth,
                        'business_unit': product.business_unit,
                        'restricted_states': product.restricted_states,
                        'restrict_to_all_states': product.restrict_to_all_states,
                        'sf_product_id': product.sf_product_id,
                        'recommended_brands': product.recommended_brands,
                    });
                });
                formattedData.selections[brand].products = products;
            }
        });

        return formattedData;
    }
};

ReservationData.data = {
    Selling_BU: '',
    URI: '',
    ContactID: '',
    Campaign: '',
    UTM_source: '',
    UTM_medium: 'website',
    UTM_content: '',
    UTM_campaign: '',
    UTM_term: '',
    RepId: '',
    repEmail: '',
    Dialed: false,
    FirstName: '',
    LastName: '',
    ContactEmail: '',
    Phone: '',
    State: '',
    Zip: '',
    Company: '',
    Title: '',
    willAttend: null,
    brand_slug: '',
    Comments: '',
    CAID: '',
    fivemil: '',
    ManheimMulti: '',
    ContractEndDate: '',
    CurrentDMSProvider: '',
    WhereDemo: '',
    ShowYear: '',
    ShowName: '',
    tradeshowId: null,
    selections: {},
    recommended_brands: [],
    status: {},
    audience: 'gen',
    GlobalWebID: '',
    GoogleAnalyticsClientID: '',
    UniformResourceIdentifier: '',
    BatchID: '',
    SMS_Opt_In: true,
    JobID: '',
    sfFieldLengths: {
        UTM_term: 50,
        Campaign: 18,
        UTM_source: 80,
        UTM_medium: 80,
        UTM_content: 80,
        UTM_campaign: 80,
        UTM_term: 50,
        RepId: 15,
        ShowYear: 50,
        ShowName: 50,
        CAID: 30,
    },
    validate: {
        'labels': {
            'FirstName': 'First Name',
            'LastName': 'Last Name',
            'ContactEmail': 'Email Address',
            'Company': 'Dealership Name',
            'Phone' : 'Mobile Phone Number',
            'willAttend': 'Are you planning on attending?',
            'repEmail': 'Rep Email Address'
        },
        'fields': {
            'exists': [
                'Zip',
                'Company'
            ],
            'min_length': {
                'FirstName': 2,
                'LastName': 2
            },
            'max_length': {
                'FirstName': 40,
                'LastName': 40,
                'Comments': 1000,
                'Company': 50,
                'Title': 80,
                'Zip': 10,
                'ContactEmail': 254,
                'CAID': 10,
            },
            'email': [
                'ContactEmail'
            ],
            'phone': [
                'Phone'
            ],
            'zip': [
                'Zip'
            ],
        }
    }
}

export { ReservationData as default}